import React from 'react';
import { SvgContainer, SvgContainerProps } from './SvgContainer';

export const EmailIcon = (props: SvgContainerProps) => (
  <SvgContainer {...props}>
    <path
      strokeLinecap="round"
      d="M16.5 12a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm0 0c0 1.657 1.007 3 2.25 3S21 13.657 21 12a9 9 0 10-2.636 6.364M16.5 12V8.25"
    />
  </SvgContainer>
);
